/**
 * Avatar definitions are data, not branching UI logic. Add future department
 * heads and specialists here (or inject an equivalent registry from the app).
 *
 * The GLB URLs are stable public URLs expected after the canonical, unchanged
 * binaries are copied into public/assets/avatars. No remote asset is used.
 */
export const AVATAR_KINDS = Object.freeze({
  SYSTEM: 'system',
  DEPARTMENT_HEAD: 'department-head',
  SPECIALIST: 'specialist',
  PARTNER: 'partner',
});

export const AVATAR_STATES = Object.freeze([
  'idle',
  'listening',
  'speaking',
  'thinking',
  'guiding',
]);

const MESHY_UPRIGHT_ORIENTATION = '0deg 90deg 0deg';

export const DEFAULT_AVATAR_REGISTRY = Object.freeze({
  linc: Object.freeze({
    id: 'linc',
    name: 'Linc',
    role: 'Oversight',
    kind: AVATAR_KINDS.SYSTEM,
    persistent: true,
    priority: 100,
    defaultDock: 'bottom-right',
    accent: '#31d7ff',
    assetUrl: '/avatars/linc/linc-v1.glb',
    fallbackAssetUrl: '/avatars/linc/linc-character-v1.glb',
    posterUrl: null,
    // Canonical Meshy/Mixamo exports use Z-up. Correct only at render time.
    orientation: MESHY_UPRIGHT_ORIENTATION,
    cameraOrbit: '0deg 78deg 90%',
    fieldOfView: '27deg',
    animationClips: Object.freeze({
      idle: null,
      listening: null,
      speaking: 'Stand_and_Chat',
      thinking: null,
      guiding: 'Stand_and_Chat',
    }),
  }),
  arti: Object.freeze({
    id: 'arti',
    name: 'Arti',
    role: 'Creative + Build',
    kind: AVATAR_KINDS.DEPARTMENT_HEAD,
    persistent: false,
    priority: 90,
    defaultDock: 'bottom-left',
    accent: '#ff69cf',
    assetUrl: '/avatars/arti/arti-v1.glb',
    fallbackAssetUrl: '/avatars/arti/arti-character-v1.glb',
    orientation: MESHY_UPRIGHT_ORIENTATION,
    cameraOrbit: '0deg 78deg 92%',
    fieldOfView: '27deg',
    moduleRules: Object.freeze({
      moduleIds: Object.freeze([
        'lincforge',
        'linkforge',
        'forgelinc',
        'buildlinc',
        'creative',
        'design',
      ]),
      pathPrefixes: Object.freeze([
        '/lincforge',
        '/linkforge',
        '/forgelinc',
        '/buildlinc',
        '/design',
      ]),
    }),
    animationClips: Object.freeze({
      idle: null,
      listening: 'Listening_Gesture',
      speaking: null,
      thinking: null,
      guiding: null,
    }),
  }),
});

export default DEFAULT_AVATAR_REGISTRY;
